import { z } from 'zod';
import { DeploymentTypeSchema } from './organisation.js';
/**
 * Installation SUMMARY records — deliberately minimal for Stage 1.
 * Full fleet telemetry is Stage 4. Only non-PHI operational metadata:
 * a version string, a health flag and a last-seen timestamp.
 */
export const InstallationHealthSchema = z.enum(['healthy', 'degraded', 'unknown']);
/**
 * Health as CONTROL evaluates it, which is not the same vocabulary a tenant is
 * allowed to report. A tenant can say healthy, degraded or unknown; only
 * Control can say 'stale', because staleness is a statement about the ABSENCE
 * of a heartbeat and no absent heartbeat can describe itself.
 *
 * Kept separate from InstallationHealthSchema deliberately: widening the
 * reported enum would let a tenant claim 'stale' about itself, which is
 * meaningless, and would silently accept it at the telemetry boundary.
 */
export const EffectiveInstallationHealthSchema = z.enum([
    'healthy',
    'degraded',
    'stale',
    'unknown',
]);
export const InstallationSummarySchema = z.object({
    id: z.uuid(),
    organisationId: z.uuid(),
    /** Stable installation identifier issued by the platform, e.g. "inst-...". */
    installationKey: z.string(),
    deploymentType: DeploymentTypeSchema,
    appVersion: z.string().nullable(),
    health: InstallationHealthSchema,
    lastSeenAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
//# sourceMappingURL=installations.js.map